// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cabin-cards-wrapper {
  min-width: 68vw;
  padding: 0;
}
.cabin-cards-wrapper span {
  text-transform: capitalize;
}
.cabin-cards-wrapper .cabin-card {
  width: 98%;
  display: flex;
  gap: 30px;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 15px;
}
.cabin-cards-wrapper .cabin-card .cabin-left-wrapper {
  width: 50%;
}
.cabin-cards-wrapper .cabin-card .cabin-left-wrapper .cabin-name {
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-align: center;
}
.cabin-cards-wrapper .cabin-card .cabin-left-wrapper .cabin-img-wrapper {
  width: 100%;
  height: 255px;
}
.cabin-cards-wrapper .cabin-card .cabin-left-wrapper .cabin-img-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 6px;
}
.cabin-cards-wrapper .cabin-card .cabin-left-wrapper .cabin-rooms {
  font-size: 18px;
  font-weight: 700;
  text-align: center;
}
.cabin-cards-wrapper .cabin-card .cabin-left-wrapper .cabin-rooms.red {
  color: #D40D0D;
}
.cabin-cards-wrapper .cabin-card .cabin-left-wrapper .cabin-rooms.green {
  color: #17A300;
}
.cabin-cards-wrapper .cabin-card .cabin-details-wrapper {
  width: 50%;
  margin-top: 40px;
}
.cabin-cards-wrapper .cabin-card .cabin-details-wrapper .facilities-wrapper span {
  white-space: break-spaces;
}
.cabin-cards-wrapper .cabin-card .cabin-details-wrapper .cabin-facilities, .cabin-cards-wrapper .cabin-card .cabin-details-wrapper .cabin-occupancy {
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0.03em;
  color: #000;
}

.no-rooms {
  font-size: 18px;
  color: #D40D0D;
}`, "",{"version":3,"sources":["webpack://./src/components/Modals/ItineraryInfoModal/CabinCard/style.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,UAAA;AACJ;AACI;EACI,0BAAA;AACR;AAEI;EACI,UAAA;EACA,aAAA;EACA,SAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;AAAR;AAEQ;EACI,UAAA;AAAZ;AAEY;EACI,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;AAAhB;AAGW;EACC,WAAA;EACA,aAAA;AADZ;AAEY;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AAAhB;AAIY;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;AAFhB;AAIgB;EACI,cAAA;AAFpB;AAKgB;EACI,cAAA;AAHpB;AAQQ;EACI,UAAA;EACA,gBAAA;AANZ;AASgB;EACI,yBAAA;AAPpB;AAWY;EACI,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,WAAA;AAThB;;AAeA;EACI,eAAA;EACA,cAAA;AAZJ","sourcesContent":[".cabin-cards-wrapper {\n    min-width: 68vw;\n    padding: 0;\n\n    span {\n        text-transform: capitalize;\n    }\n\n    .cabin-card {\n        width: 98%;\n        display: flex;\n        gap: 30px;\n        border: 1px solid #ddd;\n        border-radius: 6px;\n        padding: 15px;\n\n        .cabin-left-wrapper {\n            width: 50%;\n\n            .cabin-name {\n                font-size: 20px;\n                font-weight: 700;\n                letter-spacing: 0.03em;\n                text-align: center;\n            }\n\n           .cabin-img-wrapper {\n            width: 100%;\n            height: 255px;\n            img {\n                width: 100%;\n                height: 100%;\n                object-fit: cover;\n                border-radius: 6px;\n            }\n            } \n\n            .cabin-rooms {\n                font-size: 18px;\n                font-weight: 700;\n                text-align: center;\n\n                &.red {\n                    color: #D40D0D;\n                }\n\n                &.green {\n                    color: #17A300;\n                }\n            }\n        }\n\n        .cabin-details-wrapper {\n            width: 50%;\n            margin-top: 40px;\n\n            .facilities-wrapper{\n                span{\n                    white-space: break-spaces;\n                }\n            }\n\n            .cabin-facilities, .cabin-occupancy {\n                font-size: 16px;\n                font-weight: 400;\n                letter-spacing: 0.03em;\n                color: #000;\n            }\n        }\n    }\n}\n\n.no-rooms{\n    font-size: 18px;\n    color: #D40D0D;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
